/**
 * Lazy load jsQR only when QR scanning is needed
 * This saves ~316KB from the initial bundle
 */

let jsQRModule: any = null

export async function loadJsQR() {
  if (jsQRModule) return jsQRModule
  
  // Dynamic import - this creates a separate chunk
  const module = await import("jsqr")
  jsQRModule = module.default
  return jsQRModule
}
